import clsx from 'clsx';

import s from './CustomToastContent.module.css';

export const CustomToastContent = ({ icon, message, type, typeLabel }) => {
	return (
		<div className={clsx(s.toast, 'body-medium-sm')} data-type={type} role='alert' aria-live='assertive'>
			<span className={s.toast_icon} aria-hidden='true'>
				{icon}
			</span>
			<span className={s.toast_message}>
				<span className='visually-hidden'>{typeLabel}: </span>
				{message}
			</span>
		</div>
	);
};
